const Footer = () =>
  <footer className="py-4 text-center small footer">
    Copyright © Colby Nolasco 2024.
  </footer>;

export default Footer;
